@use "sass:math";
@import "~/styles/variables";

.Grid {
  display: flex;
  flex: 1;

  &.fullHeight {
    height: 100%;
    min-height: 0;
  }

  &.column {
    flex-direction: column;
  }

  &.wrap {
    flex-wrap: wrap;
  }

  &.align {
    &_right {
      justify-content: flex-end;
    }

    &_center {
      justify-content: center;
    }

    &_spaced {
      justify-content: space-between;
    }
  }

  &.valign {
    &_top {
      align-items: flex-start;
    }

    &_center {
      align-items: center;
    }

    &_bottom {
      align-items: flex-end;
    }
  }

  @each $size, $val in $space-sizes {
    &.gutters_#{$size} {
      margin-left: -(math.div(map-get($space-sizes, $size), 2));
      margin-right: -(math.div(map-get($space-sizes, $size), 2));

      > div {
        margin-left: math.div(map-get($space-sizes, $size), 2);
        margin-right: math.div(map-get($space-sizes, $size), 2);
      }
    }

    &.vgutters_#{$size} {
      > div {
        margin-bottom: map-get($space-sizes, $size);
      }
    }

    &.cellPadding_#{$size} > div {
      padding: map-get($space-sizes, $size);
    }
  }
}

.GridSeparator {
  align-self: stretch;
  background: $border-color;
  flex-shrink: 0;
  margin: 0 !important;
  padding: 0 !important;
  width: 1px;

  &_inset {
    margin-bottom: $space-s !important;
    margin-top: $space-s !important;
  }
}
